const Loader = ({ label = "Loading..." }) => {   
    const loaderStyle = {
        width: "20px",
        height: "20px",
        border: "4px solid #f3f3f3",
        borderTop: "4px solid #324F78",
        borderRadius: "50%",
        animation: "spin 1s linear infinite"
    };

    return (
        <>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={loaderStyle}>
                    <style>
                        {`
                            @keyframes spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}
                    </style>
                </div>
                <span>{label}</span>
            </div>
        </>
    );
};

export default Loader;